import { render, staticRenderFns } from "./AcceptedOrderListProducts.vue?vue&type=template&id=491c376e&"
import script from "./AcceptedOrderListProducts.vue?vue&type=script&lang=js&"
export * from "./AcceptedOrderListProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports